import {EwayBillActions} from "../actions/EwayBillActions";
import { downloadEwayBill, fetchEwayBillDetails} from "../network/EwayBillDetailsAPI";
import {EwayBillErrorMessages} from "../constants/EwayBillErrorMessages";

export const EwayBillReducer = (state, action) => {
    switch (action.type) {
        case EwayBillActions.FETCH_LMVRID_DETAILS:
            fetchEwayBillDetails(action.dispatcher);
            return {...state, loading: true, success: true, downloadEwayBillFailure: false};

        case EwayBillActions.SET_LMVRID_DETAILS:
            return {...state, lmVRIDs: action.data, loading: false, success: true, downloadEwayBillFailure: false};

        case EwayBillActions.DOWNLOAD_EWAYBILL:
            const { lmVRID} = action.data;
            downloadEwayBill(action.dispatcher, lmVRID)
            return {
                ...state, loading: false, success: true, downloadEwayBillFailure: false
            };

        case EwayBillActions.SET_ERROR_WHILE_FETCHING_LMVRIDS:
            return {
                ...state, loading: false, success: false, errorMessage: EwayBillErrorMessages.ERROR_WHILE_FETCHING_LMVRID,
                downloadEwayBillFailure: false
            };

        case EwayBillActions.SET_ERROR_WHILE_FETCHING_EWAYBILL:
            return {
                ...state, loading: false, success: false, errorMessage: EwayBillErrorMessages.ERROR_WHILE_FETCHING_EWAYBILL,
                downloadEwayBillFailure: true
            };

        case EwayBillActions.SET_ERROR_WHILE_CREATING_PDF:
            return {
                ...state, loading: false, success: false, errorMessage: EwayBillErrorMessages.ERROR_WHILE_GENERATING_PDF,
                downloadEwayBillFailure: true
            };


        default:
            return state
    }
};


// WEBPACK FOOTER //
// ./src/components/eWayBill/reducer/EwayBillReducer.js